import { j as e } from "./react-944c88e2.js";
import { InfoIcon as Ze } from "@chakra-ui/icons";
import { AccordionButton as Le, Box as m, Heading as H, AccordionIcon as Ke, HStack as Ne, Text as i, SimpleGrid as J, Center as Ue, Input as T, Accordion as Y, AccordionItem as A, AccordionPanel as P, useDisclosure as eo, useClipboard as oo, Drawer as ro, DrawerOverlay as io, DrawerContent as lo, DrawerCloseButton as no, DrawerBody as to, Breadcrumb as so, BreadcrumbItem as Be, Menu as co, MenuButton as ao, BreadcrumbLink as ho, MenuList as xo, MenuItem as Ge, Flex as c, Stack as d, StackDivider as mo, Image as We, Button as k, Checkbox as po, Select as jo, Table as De, Thead as Re, Tr as v, Th as $, Tbody as $e, Td as b, VStack as uo, FormControl as Me, FormLabel as He, Switch as Oe, Tooltip as go, Icon as fo, DrawerFooter as bo } from "@chakra-ui/react";
import { s as j } from "./lodash-bd0366b5.js";
import { useState as _, lazy as Co, useEffect as U } from "react";
import "./firebase-d0134a8f.js";
import "./@firebase-868b0e52.js";
import "./node-forge-b3503c74.js";
import { m as yo } from "./useAccount-8a1c7225.js";
import { l as So, m as wo, a as vo } from "./domains-162ab8d8.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import "./usehooks-ts-53aa4768.js";
import { u as To } from "./features-4c20b5b5.js";
import { u as qe, z as Io, av as Ve } from "./eMyAsurionProvider-ec3ed988.js";
import "./providers-e896aa48.js";
import "@tanstack/react-query";
import { t as zo } from "./index-d9fb9451.js";
import { l as Fo, C as ko } from "./react-best-gradient-color-picker-87da9ea7.js";
import { i as Ao } from "./use-immer-ae8601ab.js";
import { getChakraColorScale as Po } from "./myasurion-shared.colors.es.js";
import "./@contentful-cca97bae.js";
import "./crypto-js-1bed509f.js";
import "react-router-dom";
import "./@chakra-ui-f377b543.js";
import "./lodash.mergewith-9d927056.js";
import "@emotion/react";
import "./chakraReact-cc461a14.js";
import "./@zag-js-985153e8.js";
import "framer-motion";
import "./react-fast-compare-e81d3847.js";
import "@emotion/styled";
import "./axios-d6123f02.js";
import "./myasurion-shared.carrier.es.js";
import "./typescript-collections-b97a1d6d.js";
import "./contentful-ed636ee7.js";
import "./moment-a2f61e40.js";
import "./browser-detect-b0c87b70.js";
import "./@aws-amplify-21547700.js";
import "./js-cookie-d54fed8f.js";
import "./@aws-crypto-5d5961ee.js";
import "./tslib-1406810b.js";
import "./@smithy-2331ff76.js";
import "./rxjs-c3576f66.js";
import "./uuid-5adc31c9.js";
import "./aws-amplify-2a9a372d.js";
import "./process-481e9afe.js";
import "./myasurion-shared.ereviewSubmission.es.js";
import "./cleave.js-cf58c059.js";
import "./colornames-7577e860.js";
import "./LockIcon-3715d1f2.js";
import "./react-responsive-carousel-5d5a6886.js";
import "./react-easy-swipe-5c12dd2c.js";
import "./prop-types-5dc3ead4.js";
import "./react-is-fdabd8df.js";
import "./object-assign-d7a4d3b1.js";
import "./classnames-0d222af1.js";
import "./xstate-03560826.js";
import "./@xstate-e6d7a3e3.js";
import "./use-sync-external-store-9c68af99.js";
import "./use-isomorphic-layout-effect-37cd9e90.js";
import "./file-saver-1aff1f79.js";
import "@react-oauth/google";
import "./formik-a668a7f5.js";
import "./deepmerge-c6c56555.js";
import "./lodash-es-9bce7d1a.js";
import "./tiny-warning-b49e0329.js";
import "./hoist-non-react-statics-0f4f9040.js";
import "./myasurion-shared.widgets.es.js";
import "./yup-c645f9e0.js";
import "./property-expr-5b4294d4.js";
import "./tiny-case-47ef5535.js";
import "./toposort-f63cd5fa.js";
import "./myasurion-shared.profile.es.js";
import "./date-fns-9d457cca.js";
import "./@babel-dad84d6f.js";
import "react-dom";
import "./tinycolor2-e04834eb.js";
import "./html2canvas-c76dc20e.js";
import "./immer-4e3ccba6.js";
import "./color-58d56877.js";
import "./color-string-43e78257.js";
import "./color-name-0faa9c28.js";
import "./simple-swizzle-41fe54f9.js";
import "./color-convert-15c02049.js";
const M = ({ children: n, ...a }) => /* @__PURE__ */ e.jsxs(Le, { ...a, children: [
  /* @__PURE__ */ e.jsx(m, { as: "span", flex: "1", textAlign: "left", children: /* @__PURE__ */ e.jsx(H, { fontSize: "lg", children: n }) }),
  /* @__PURE__ */ e.jsx(Ke, {})
] }), B = ({ children: n, ...a }) => /* @__PURE__ */ e.jsx(Ne, { justify: "space-between", align: "center", gap: 3, ...a, children: n }), G = ({ children: n, ...a }) => /* @__PURE__ */ e.jsx(
  i,
  {
    fontWeight: "bold",
    fontSize: "sm",
    color: "gray.400",
    letterSpacing: "wide",
    textTransform: "uppercase",
    ...a,
    children: n
  }
), Bo = ({ color: n = "" }) => /^#[0-9A-F]{6}$/i.test(n) ? /* @__PURE__ */ e.jsx(J, { spacing: 0, columns: 5, children: Object.entries(Po(n)).map(([u, s]) => /* @__PURE__ */ e.jsx(Ue, { background: s, py: 2, px: 3, children: /* @__PURE__ */ e.jsx(i, { fontSize: "xs", children: u }) }, `primary-color-${u}`)) }) : /* @__PURE__ */ e.jsx(i, { textAlign: "center", children: "Invalid Hex Color." }), q = [
  {
    id: 1,
    name: "color1",
    default: "#18A2AD",
    hex: null,
    rgb: null,
    active: !0
  },
  {
    id: 2,
    name: "color2",
    default: "#FF3838",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 3,
    name: "color3",
    default: "#152532",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 4,
    name: "color4",
    default: "#2ECC71",
    hex: null,
    rgb: null,
    active: !1
  },
  {
    id: 5,
    name: "color5",
    default: "#e9dd41",
    hex: null,
    rgb: null,
    active: !1
  }
], C = ({ title: n, colorValue: a = "#000", colorCode: u, type: s }) => {
  var z, D;
  const { data: o, updateConfig: x } = qe(), [, O] = Ao({
    collection: [...q],
    activeColorId: (z = q.find((t) => t.active)) == null ? void 0 : z.id,
    currentColor: (D = q.find((t) => t.active)) == null ? void 0 : D.default
  }), [V, I] = _(a), { valueToHex: E, isGradient: g } = Fo.useColorPicker(V, I), W = E(), y = (t, Q, F) => {
    const L = setTimeout(() => {
      O((p) => {
        const R = p.collection.find((S) => S.id === p.activeColorId);
        p.currentColor = t, R && (R.hex = t), x(!g && s === "solid" ? j(F, u, W) : j(F, u, t));
      }), I(t);
    }, 100);
    return () => {
      clearTimeout(L);
    };
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(B, { children: [
      /* @__PURE__ */ e.jsx(G, { children: n }),
      /* @__PURE__ */ e.jsx(
        T,
        {
          height: "20px",
          width: "100px",
          value: a,
          onChange: (t) => {
            x(j(o, u, t.target.value));
          }
        }
      )
    ] }),
    s !== "gradient" && /* @__PURE__ */ e.jsx(Bo, { color: a }),
    /* @__PURE__ */ e.jsx(Y, { allowToggle: !0, children: /* @__PURE__ */ e.jsxs(A, { children: [
      /* @__PURE__ */ e.jsx("h2", { children: /* @__PURE__ */ e.jsxs(Le, { children: [
        /* @__PURE__ */ e.jsx(m, { as: "span", flex: "1", textAlign: "left", children: "Color Picker" }),
        /* @__PURE__ */ e.jsx(Ke, {})
      ] }) }),
      /* @__PURE__ */ e.jsx(P, { pb: 4, children: /* @__PURE__ */ e.jsx(
        ko,
        {
          value: W,
          onChange: (t) => y(t, u, o),
          hideGradientControls: !g && s === "solid",
          hideGradientType: !g && s === "solid",
          hideGradientAngle: !g && s === "solid",
          hideGradientStop: !g && s === "solid",
          hideControls: !g && s === "solid"
        }
      ) })
    ] }) })
  ] });
}, Ee = Co(() => import("./eMyAsurionProvider-ec3ed988.js").then((n) => n.aw).then((n) => ({ default: n.TextScript }))), Go = [
  { locale: "en-US" },
  { locale: "zh-Hant-TW" },
  { locale: "th-TH" },
  { locale: "ko-KR" },
  { locale: "ms-MY" }
], xi = ({
  enabled: n = !1,
  placement: a = "left",
  size: u = "xl"
}) => {
  var N, ee, oe, re, ie, le, ne, te, se, ce, de, ae, he, xe, me, pe, je, ue, ge, fe, be, Ce, ye, Se, we, ve, Te, Ie, ze, Fe, ke, Ae;
  const s = eo(), { data: o, updateConfig: x, refetchConfig: O, saveConfig: V, conf: I } = qe(), { languagesAvailable: E } = o, { onCopy: g, hasCopied: W } = oo(JSON.stringify(o, null, 2)), [y, z] = _("Translations"), [D] = yo({ authorization: "", token: "", id: "" }), [t, Q] = _(), { isOn: F } = To("devtools"), {
    // isEnabled,
    // updateIsEnabled,
    module: L,
    // updateActiveLanguage,
    language: p,
    updateIsEditingMode: R,
    isEditingMode: S,
    updateIsDevToolsOpen: Je,
    isDevToolsEnabled: Ye,
    updateIsDevToolsEnabled: _e,
    isKeyShown: X,
    setIsKeyShown: Z
  } = Io(), K = So() ? wo() : vo();
  return U(() => {
    Je(s.isOpen);
  }, [s]), U(() => {
    (async () => {
      var l;
      const h = await ((l = Ve.getStringManagerInstance(p)) == null ? void 0 : l.getGroup(
        "Global"
      ));
      Q(h);
    })();
  }, [y, p]), U(() => {
    _e(F && n);
  }, [n, F]), !n || !Ye ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(ro, { placement: a, size: u, ...s, children: [
      /* @__PURE__ */ e.jsx(io, {}),
      /* @__PURE__ */ e.jsxs(lo, { minH: "300px", pt: "60px", children: [
        /* @__PURE__ */ e.jsx(no, { mt: "60px" }),
        /* @__PURE__ */ e.jsxs(to, { pt: 0, children: [
          /* @__PURE__ */ e.jsxs(so, { py: 4, children: [
            /* @__PURE__ */ e.jsx(Be, { children: /* @__PURE__ */ e.jsx(i, { fontWeight: "bold", letterSpacing: "tight", children: "MyAsurion DevTools" }) }),
            /* @__PURE__ */ e.jsx(Be, { children: /* @__PURE__ */ e.jsxs(co, { children: [
              /* @__PURE__ */ e.jsx(ao, { as: ho, children: y }),
              /* @__PURE__ */ e.jsxs(xo, { children: [
                /* @__PURE__ */ e.jsx(
                  Ge,
                  {
                    onClick: () => {
                      z("Translations");
                    },
                    children: "Translations"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ge,
                  {
                    onClick: () => {
                      z("Config");
                    },
                    children: "Config"
                  }
                )
              ] })
            ] }) })
          ] }),
          /* @__PURE__ */ e.jsxs(J, { w: "full", columns: 2, mb: 4, gap: 4, children: [
            /* @__PURE__ */ e.jsxs(
              c,
              {
                px: 3,
                py: 2,
                bg: "primary.200",
                justify: "space-between",
                borderRadius: "md",
                gap: 2,
                align: "center",
                children: [
                  /* @__PURE__ */ e.jsx(i, { fontSize: "xs", color: "onPrimary.500", letterSpacing: "wider", children: "PARTNER" }),
                  /* @__PURE__ */ e.jsx(i, { fontSize: "sm", fontWeight: "bold", color: "onPrimary.500", children: o == null ? void 0 : o.partner })
                ]
              }
            ),
            /* @__PURE__ */ e.jsxs(
              c,
              {
                px: 3,
                py: 2,
                bg: "primary.200",
                justify: "space-between",
                borderRadius: "md",
                gap: 2,
                align: "center",
                children: [
                  /* @__PURE__ */ e.jsx(i, { fontSize: "xs", color: "onPrimary.500", letterSpacing: "wider", children: "PROGRAM" }),
                  /* @__PURE__ */ e.jsx(i, { fontSize: "sm", fontWeight: "bold", color: "onPrimary.500", children: o == null ? void 0 : o.program })
                ]
              }
            )
          ] }),
          y === "Config" && /* @__PURE__ */ e.jsx(m, { children: /* @__PURE__ */ e.jsxs(Y, { children: [
            /* @__PURE__ */ e.jsxs(A, { children: [
              /* @__PURE__ */ e.jsx(M, { children: "Global Theme" }),
              /* @__PURE__ */ e.jsx(P, { pb: 6, children: /* @__PURE__ */ e.jsxs(
                d,
                {
                  gap: 2,
                  divider: /* @__PURE__ */ e.jsx(mo, { borderColor: "gray.200" }),
                  children: [
                    /* @__PURE__ */ e.jsxs(d, { gap: 2, children: [
                      /* @__PURE__ */ e.jsxs(B, { children: [
                        /* @__PURE__ */ e.jsx(G, { children: "Logo" }),
                        /* @__PURE__ */ e.jsx(
                          T,
                          {
                            height: "20px",
                            width: "full",
                            maxW: "300px",
                            value: ((N = o == null ? void 0 : o.theme) == null ? void 0 : N.logo) || "",
                            onChange: (r) => {
                              x(
                                j(
                                  o,
                                  "theme.logo",
                                  r.target.value
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e.jsx(
                        We,
                        {
                          src: (ee = o == null ? void 0 : o.theme) == null ? void 0 : ee.logo,
                          height: "100%",
                          maxHeight: "60px",
                          border: "1px solid",
                          borderColor: "gray.200",
                          borderRadius: "md",
                          overflow: "hidden",
                          w: "full",
                          h: "52px",
                          objectFit: "contain"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Primary Color",
                        colorValue: ((re = (oe = o == null ? void 0 : o.theme) == null ? void 0 : oe.colors) == null ? void 0 : re.primary) || "",
                        colorCode: "theme.colors.primary",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "On Primary Color",
                        colorValue: ((le = (ie = o == null ? void 0 : o.theme) == null ? void 0 : ie.colors) == null ? void 0 : le.onPrimary) || "",
                        colorCode: "theme.colors.onPrimary",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Accent Color",
                        colorValue: ((te = (ne = o == null ? void 0 : o.theme) == null ? void 0 : ne.colors) == null ? void 0 : te.accent) || "",
                        colorCode: "theme.colors.accent",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Body Text Color",
                        colorValue: ((se = o == null ? void 0 : o.theme) == null ? void 0 : se.colors.bodyTextColor) || ((ae = (de = (ce = zo) == null ? void 0 : ce.semanticTokens) == null ? void 0 : de.colors) == null ? void 0 : ae["chakra-body-text"]._light),
                        colorCode: "theme.colors.bodyTextColor",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Banner Gradient",
                        colorValue: ((xe = (he = o == null ? void 0 : o.theme) == null ? void 0 : he.colors) == null ? void 0 : xe.bannerGradient) || "",
                        colorCode: "theme.colors.bannerGradient",
                        type: "gradient"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Banner Color",
                        colorValue: ((pe = (me = o == null ? void 0 : o.theme) == null ? void 0 : me.colors) == null ? void 0 : pe.bannerColor) || "",
                        colorCode: "theme.colors.bannerColor",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Feedback Gradient",
                        colorValue: ((ue = (je = o == null ? void 0 : o.theme) == null ? void 0 : je.colors) == null ? void 0 : ue.feedbackGradient) || "",
                        colorCode: "theme.colors.feedbackGradient",
                        type: "gradient"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsx(d, { gap: 2, children: /* @__PURE__ */ e.jsx(
                      C,
                      {
                        title: "Header Theme",
                        colorValue: ((fe = (ge = o == null ? void 0 : o.theme) == null ? void 0 : ge.header) == null ? void 0 : fe.bg) || "",
                        colorCode: "theme.header.bg",
                        type: "solid"
                      }
                    ) }),
                    /* @__PURE__ */ e.jsxs(d, { gap: 2, children: [
                      /* @__PURE__ */ e.jsxs(B, { children: [
                        /* @__PURE__ */ e.jsx(G, { children: "Header Logo" }),
                        /* @__PURE__ */ e.jsx(
                          T,
                          {
                            height: "20px",
                            width: "full",
                            maxW: "300px",
                            value: ((be = o == null ? void 0 : o.theme) == null ? void 0 : be.header.logo) || "",
                            onChange: (r) => {
                              x(
                                j(
                                  o,
                                  "theme.header.logo",
                                  r.target.value
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e.jsx(
                        We,
                        {
                          src: (Ce = o == null ? void 0 : o.theme) == null ? void 0 : Ce.header.logo,
                          height: "100%",
                          maxHeight: "60px",
                          border: "1px solid",
                          borderColor: "gray.200",
                          borderRadius: "md",
                          overflow: "hidden",
                          w: "full",
                          h: "52px",
                          objectFit: "contain"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ e.jsxs(d, { gap: 2, children: [
                      /* @__PURE__ */ e.jsx(H, { fontSize: "lg", children: "Button Settings" }),
                      /* @__PURE__ */ e.jsx(
                        Ue,
                        {
                          p: 4,
                          borderRadius: "md",
                          bg: "gray.50",
                          w: "full",
                          children: /* @__PURE__ */ e.jsx(k, { children: "Click me!" })
                        }
                      ),
                      /* @__PURE__ */ e.jsxs(B, { children: [
                        /* @__PURE__ */ e.jsx(G, { children: "Uppercase Text" }),
                        /* @__PURE__ */ e.jsx(
                          po,
                          {
                            isChecked: ((we = (Se = (ye = o == null ? void 0 : o.theme) == null ? void 0 : ye.baseComponents) == null ? void 0 : Se.Button) == null ? void 0 : we.textTransform) === "uppercase",
                            onChange: (r) => {
                              x(
                                j(
                                  o,
                                  "theme.baseComponents.Button.textTransform",
                                  r.target.checked ? "uppercase" : "none"
                                )
                              );
                            }
                          }
                        )
                      ] }),
                      /* @__PURE__ */ e.jsxs(B, { children: [
                        /* @__PURE__ */ e.jsx(G, { children: "Letter Spacing" }),
                        /* @__PURE__ */ e.jsx(
                          jo,
                          {
                            value: ((Ie = (Te = (ve = o == null ? void 0 : o.theme) == null ? void 0 : ve.baseComponents) == null ? void 0 : Te.Button) == null ? void 0 : Ie.letterSpacing) || "normal",
                            onChange: (r) => {
                              x(
                                j(
                                  o,
                                  "theme.baseComponents.Button.letterSpacing",
                                  r.target.value
                                )
                              );
                            },
                            children: [
                              "tighter",
                              "tight",
                              "normal",
                              "wide",
                              "wider",
                              "widest"
                            ].map((r) => /* @__PURE__ */ e.jsx("option", { value: r, children: r }, r))
                          }
                        )
                      ] })
                    ] })
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsxs(A, { children: [
              /* @__PURE__ */ e.jsx(M, { children: "Custom Component Styles" }),
              /* @__PURE__ */ e.jsx(P, { pb: 6, children: /* @__PURE__ */ e.jsxs(d, { gap: 2, children: [
                /* @__PURE__ */ e.jsxs(
                  m,
                  {
                    gap: 2,
                    py: 4,
                    px: 3,
                    borderRadius: "md",
                    bg: "gray.50",
                    children: [
                      /* @__PURE__ */ e.jsx(H, { fontSize: "md", children: "favicon" }),
                      /* @__PURE__ */ e.jsxs(De, { variant: "striped", size: "sm", mt: 4, children: [
                        /* @__PURE__ */ e.jsx(Re, { children: /* @__PURE__ */ e.jsxs(v, { children: [
                          /* @__PURE__ */ e.jsx($, { children: "Feature" }),
                          /* @__PURE__ */ e.jsx($, { children: "Value" })
                        ] }) }),
                        /* @__PURE__ */ e.jsx($e, { children: /* @__PURE__ */ e.jsxs(v, { children: [
                          /* @__PURE__ */ e.jsx(b, { children: "favicon" }),
                          /* @__PURE__ */ e.jsx(b, { children: /* @__PURE__ */ e.jsx(
                            T,
                            {
                              height: "20px",
                              value: ((ze = o == null ? void 0 : o.theme) == null ? void 0 : ze.favicon) || "",
                              onChange: (r) => {
                                x(
                                  j(
                                    o,
                                    "theme.favicon",
                                    r.target.value
                                  )
                                );
                              }
                            }
                          ) })
                        ] }, "component-styles--favicon") })
                      ] })
                    ]
                  },
                  "component-styles-fav"
                ),
                Object.entries(((Fe = o == null ? void 0 : o.theme) == null ? void 0 : Fe.components) ?? {}).map(
                  ([r, h]) => /* @__PURE__ */ e.jsxs(
                    m,
                    {
                      gap: 2,
                      py: 4,
                      px: 3,
                      borderRadius: "md",
                      bg: "gray.50",
                      children: [
                        /* @__PURE__ */ e.jsx(H, { fontSize: "md", children: r }),
                        /* @__PURE__ */ e.jsxs(
                          De,
                          {
                            variant: "striped",
                            size: "sm",
                            mt: 4,
                            children: [
                              /* @__PURE__ */ e.jsx(Re, { children: /* @__PURE__ */ e.jsxs(v, { children: [
                                /* @__PURE__ */ e.jsx($, { children: "Feature" }),
                                /* @__PURE__ */ e.jsx($, { children: "Value" })
                              ] }) }),
                              /* @__PURE__ */ e.jsx($e, { children: Object.entries(
                                h ?? {}
                              ).map(([l, f]) => {
                                var Pe;
                                return typeof f == "object" && f !== null ? /* @__PURE__ */ e.jsxs(
                                  v,
                                  {
                                    children: [
                                      /* @__PURE__ */ e.jsx(b, { children: l }),
                                      (Pe = Object.entries(
                                        f
                                      )) == null ? void 0 : Pe.map(
                                        ([
                                          w,
                                          Qe
                                        ]) => /* @__PURE__ */ e.jsxs(
                                          v,
                                          {
                                            children: [
                                              /* @__PURE__ */ e.jsx(b, {}),
                                              /* @__PURE__ */ e.jsx(b, { children: w }),
                                              /* @__PURE__ */ e.jsx(
                                                b,
                                                {
                                                  children: /* @__PURE__ */ e.jsx(
                                                    T,
                                                    {
                                                      height: "20px",
                                                      value: Qe,
                                                      onChange: (Xe) => {
                                                        x(
                                                          j(
                                                            o,
                                                            `theme.components.${r}.${l}.${w}`,
                                                            Xe.target.value
                                                          )
                                                        );
                                                      }
                                                    }
                                                  )
                                                },
                                                w
                                              )
                                            ]
                                          },
                                          w
                                        )
                                      )
                                    ]
                                  },
                                  `component-styles-${r}-${l}`
                                ) : /* @__PURE__ */ e.jsxs(
                                  v,
                                  {
                                    children: [
                                      /* @__PURE__ */ e.jsx(b, { children: l }),
                                      /* @__PURE__ */ e.jsx(b, { children: /* @__PURE__ */ e.jsx(
                                        T,
                                        {
                                          height: "20px",
                                          value: f,
                                          onChange: (w) => {
                                            x(
                                              j(
                                                o,
                                                `theme.components.${r}.${l}`,
                                                w.target.value
                                              )
                                            );
                                          }
                                        }
                                      ) })
                                    ]
                                  },
                                  `component-styles-${r}-${l}`
                                );
                              }) })
                            ]
                          }
                        )
                      ]
                    },
                    `component-styles-${r}`
                  )
                )
              ] }) })
            ] })
          ] }) }),
          y === "Translations" && /* @__PURE__ */ e.jsx(m, { children: /* @__PURE__ */ e.jsxs(
            uo,
            {
              display: "flex",
              flexFlow: "column nowrap",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ e.jsx(i, { as: "h2", fontSize: "xl", fontWeight: "bold", children: "Translations" }),
                /* @__PURE__ */ e.jsx(i, { as: "h3", fontWeight: "bold", children: "Current Active Language:" }),
                /* @__PURE__ */ e.jsx(i, { as: "h4", children: ((Ae = (ke = E || Go) == null ? void 0 : ke.find(
                  (r) => r.locale === p
                )) == null ? void 0 : Ae.name) ?? p }),
                /* @__PURE__ */ e.jsx(i, { as: "h3", fontWeight: "bold", children: "Toggle Supported Mode:" }),
                /* @__PURE__ */ e.jsxs(Me, { display: "flex", alignItems: "center", children: [
                  /* @__PURE__ */ e.jsx(He, { htmlFor: "toggle-editing", mb: "0", children: "Enable editing mode?" }),
                  /* @__PURE__ */ e.jsx(
                    Oe,
                    {
                      id: "toggle-editing",
                      isChecked: S,
                      onChange: () => {
                        S || Z(!1), R(!S);
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsxs(Me, { display: "flex", alignItems: "center", children: [
                  /* @__PURE__ */ e.jsx(He, { htmlFor: "toggle-key-shown", mb: "0", children: "Toggle translation key" }),
                  /* @__PURE__ */ e.jsx(
                    Oe,
                    {
                      id: "toggle-key-shown",
                      isChecked: S ? !1 : X,
                      onChange: () => Z(!X)
                    }
                  ),
                  /* @__PURE__ */ e.jsx(go, { label: "Translation keys will be shown when editing mode is turned off", children: /* @__PURE__ */ e.jsx(fo, { as: Ze, mx: "1rem", opacity: 0.75 }) })
                ] }),
                /* @__PURE__ */ e.jsxs(
                  m,
                  {
                    as: "ul",
                    display: "flex",
                    flexFlow: "column nowrap",
                    gap: "2",
                    w: "full",
                    py: 4,
                    children: [
                      /* @__PURE__ */ e.jsx(i, { as: "h3", fontWeight: "bold", children: "Translations Taxonomy:" }),
                      /* @__PURE__ */ e.jsxs(Y, { allowMultiple: !0, py: 2, children: [
                        t && /* @__PURE__ */ e.jsxs(A, { children: [
                          /* @__PURE__ */ e.jsx(M, { children: "Global" }),
                          /* @__PURE__ */ e.jsx(P, { children: t && t.strings && t.strings.map((r, h) => /* @__PURE__ */ e.jsxs(
                            m,
                            {
                              as: "li",
                              style: {
                                listStyle: "none"
                              },
                              boxShadow: "md",
                              borderRadius: "base",
                              py: "4",
                              px: "4",
                              w: "full",
                              children: [
                                /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                  /* @__PURE__ */ e.jsx(
                                    i,
                                    {
                                      as: "h3",
                                      fontSize: "md",
                                      fontWeight: "bold",
                                      children: "Text:"
                                    }
                                  ),
                                  /* @__PURE__ */ e.jsx(i, { as: "p", children: /* @__PURE__ */ e.jsx(
                                    Ee,
                                    {
                                      text: r.value.content ?? "",
                                      translationKey: r.value.id.replace(
                                        `${K}-`,
                                        ""
                                      ),
                                      isFull: !0
                                    }
                                  ) })
                                ] }),
                                /* @__PURE__ */ e.jsx(m, { mt: "2", children: /* @__PURE__ */ e.jsxs(
                                  c,
                                  {
                                    flexFlow: "column nowrap",
                                    gap: "2",
                                    children: [
                                      /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Module:"
                                          }
                                        ),
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: "global"
                                          }
                                        )
                                      ] }),
                                      /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Section:"
                                          }
                                        ),
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: r.value.sectionId
                                          }
                                        )
                                      ] }),
                                      /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "h4",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Path/id:"
                                          }
                                        ),
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "p",
                                            fontSize: "md",
                                            children: r.value.id.replace(
                                              `${K}-`,
                                              ""
                                            )
                                          }
                                        )
                                      ] })
                                    ]
                                  }
                                ) })
                              ]
                            },
                            `${r.key}-${h}`
                          )) })
                        ] }),
                        Ve.getScriptManager(
                          K,
                          L,
                          p
                        ).scripts.filter(
                          (r) => r.value.languageCode === p && r.value.sectionId !== "Global"
                        ).reduce(
                          (r, h) => {
                            const l = r.find(
                              (f) => f.sectionId === h.value.sectionId
                            );
                            return l ? l.values.push(h) : r.push({
                              sectionId: h.value.sectionId,
                              values: [h]
                            }), r;
                          },
                          []
                        ).map((r, h) => /* @__PURE__ */ e.jsxs(
                          A,
                          {
                            children: [
                              /* @__PURE__ */ e.jsx(M, { children: r.sectionId }),
                              /* @__PURE__ */ e.jsx(P, { children: r.values.map(
                                (l, f) => /* @__PURE__ */ e.jsxs(
                                  m,
                                  {
                                    as: "li",
                                    style: {
                                      listStyle: "none"
                                    },
                                    boxShadow: "md",
                                    borderRadius: "base",
                                    py: "4",
                                    px: "4",
                                    w: "full",
                                    children: [
                                      /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                        /* @__PURE__ */ e.jsx(
                                          i,
                                          {
                                            as: "h3",
                                            fontSize: "md",
                                            fontWeight: "bold",
                                            children: "Text:"
                                          }
                                        ),
                                        /* @__PURE__ */ e.jsx(i, { as: "p", children: /* @__PURE__ */ e.jsx(
                                          Ee,
                                          {
                                            text: l.value.text,
                                            translationKey: l.value.id,
                                            isFull: !0
                                          }
                                        ) })
                                      ] }),
                                      /* @__PURE__ */ e.jsx(m, { mt: "2", children: /* @__PURE__ */ e.jsxs(
                                        c,
                                        {
                                          flexFlow: "column nowrap",
                                          gap: "2",
                                          children: [
                                            /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Module:"
                                                }
                                              ),
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: l.value.moduleId
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Section:"
                                                }
                                              ),
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: l.value.sectionId
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Path/id:"
                                                }
                                              ),
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: l.value.id
                                                }
                                              )
                                            ] }),
                                            /* @__PURE__ */ e.jsxs(c, { flexFlow: "column nowrap", children: [
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "h4",
                                                  fontSize: "md",
                                                  fontWeight: "bold",
                                                  children: "Status"
                                                }
                                              ),
                                              /* @__PURE__ */ e.jsx(
                                                i,
                                                {
                                                  as: "p",
                                                  fontSize: "md",
                                                  children: l.status === "changed" ? `${l.status} - queued for publishing` : l.status
                                                }
                                              )
                                            ] })
                                          ]
                                        }
                                      ) })
                                    ]
                                  },
                                  f + l.value.id
                                )
                              ) })
                            ]
                          },
                          h + r.sectionId
                        ))
                      ] })
                    ]
                  }
                )
              ]
            }
          ) })
        ] }),
        y === "Config" && /* @__PURE__ */ e.jsx(bo, { children: /* @__PURE__ */ e.jsxs(J, { gap: 4, columns: 3, w: "full", children: [
          /* @__PURE__ */ e.jsx(
            k,
            {
              colorScheme: "primary",
              variant: "outline",
              onClick: () => {
                O();
              },
              children: "Reset"
            }
          ),
          /* @__PURE__ */ e.jsx(k, { colorScheme: "primary", onClick: g, children: W ? "Copied!" : "Copy Config" }),
          /* @__PURE__ */ e.jsx(
            k,
            {
              colorScheme: "primary",
              onClick: () => V({
                url: I.baseApi,
                hmacKey: I.hmacKey,
                authToken: D,
                dataConfig: o
              }),
              children: "Publish"
            }
          )
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      k,
      {
        "aria-label": "dev-tools",
        boxSize: "42px",
        borderRadius: "100%",
        pos: "fixed",
        bottom: "24px",
        left: "24px",
        zIndex: 1e3,
        colorScheme: "primary",
        onClick: s.onOpen,
        children: "</>"
      }
    )
  ] });
};
export {
  xi as MyAsurionDevTools
};
